import { useMutation } from "@tanstack/react-query";
import api from "apis";
import { DocumentTagUpdateRequest } from "apis/data-contracts";

export interface UpdateDocumentTagsParams {
  uuid: string;
  data: DocumentTagUpdateRequest;
}

export const useUpdateDocumentTags = () => {
  return useMutation({
    mutationFn: ({ uuid, data }: UpdateDocumentTagsParams) =>
      api.document.updateDocumentTags(uuid, data),
  });
};
